var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMail = function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "mail_svg__svg-icon",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4 8.667h56v5.403L32 29.342 4 14.07zm0 10.718v35.948h56V19.385L32 34.658z",
    clipRule: "evenodd"
  })));
};
export { SvgMail as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTQgOC42NjY2M0g2MFYxNC4wNjk2TDMyLjAwMDIgMjkuMzQyM0w0IDE0LjA2OTRWOC42NjY2M1pNNCAxOS4zODUxVjU1LjMzMzNINjBWMTkuMzg1M0wzMi4wMDAyIDM0LjY1NzlMNCAxOS4zODUxWiIgZmlsbD0iY3VycmVudENvbG9yIi8+PC9zdmc+";